module.exports = __webpack_public_path__ + "06_short_gray.dddee4a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/06_short_gray.png
// module id = qX0U
// module chunks = 0